if (!customElements.get('shop-the-look-slider')) {
  class ShopTheLookSlider extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      this.dotsList = this.querySelector('.js-dots-list');
      this.pagination = this.querySelector('.shop-the-look--pagination');
      this.nextArrow = this.querySelector('.shop-the-look--next');
      this.prevArrow = this.querySelector('.shop-the-look--prev');

      this.sliderOptions.breakpoints = {
        750: {
          slidesPerView: 1,
          spaceBetween: 72
        },
        990: {
          spaceBetween: 100
        },
        1100: {
          spaceBetween: 130
        },
        1200: {
          spaceBetween: 156
        }
      };

      this.sliderOptions.navigation = {
        prevEl: this.prevArrow,
        nextEl: this.nextArrow,
      }

      this.sliderOptions.pagination = {
        el: this.pagination,
        type: 'progressbar'
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.initSlider(this.querySelector('.js-slider'));
        });
      }

      this.initSlider(this.querySelector('.js-slider'));

      this.dotsList?.addEventListener('click', e => {
        const isBtn = e.target.classList.contains('js-btn');

        if (!isBtn) {
          return;
        }

        e.preventDefault();

        const btn = e.target;
        const isCurrent = btn.classList.contains('is-current');

        if (isCurrent) {
          return;
        }

        const btnIndex = +btn.dataset.index;

        this.updateActiveDot(btn);
        this.slider.slideTo(btnIndex, 300);
      });

      this.slider?.on('slideChange', e => {
        const sliderIndex = e.realIndex;
        const btn = this.dotsList?.querySelector(
          `.js-btn[data-index="${sliderIndex}"]`
        );

        this.updateActiveDot(btn);
        window.requestAnimationFrame(() => this.updateStaticActions());
        this.loadCartState();
      });

      this.slider?.on('slideChangeTransitionEnd', () => {
        this.updateStaticActions();
      });
      this.initDrawer();
      this.initProductActions();
    }

    connectedCallback() {}

    disconnectedCallback() {
      this.removeEventListener('change', this.handleVariantChange);
      document.removeEventListener('muzdan:wishlist:change', this.handleWishlistChange);
      window.removeEventListener('storage', this.handleWishlistChange);
    }

    initProductActions() {
      this.addedVariantIds = new Set();

      this.addEventListener('click', (event) => {
        const cartAction = event.target.closest('[data-shop-look-card-add-cart]');
        const wishlistAction = event.target.closest('[data-shop-look-card-wishlist]');
        const activeCartAction = event.target.closest('[data-shop-look-active-add-cart]');
        const activeWishlistAction = event.target.closest('[data-shop-look-active-wishlist]');

        if (activeCartAction && this.contains(activeCartAction)) {
          this.addProductToCart(activeCartAction);
          return;
        }

        if (activeWishlistAction && this.contains(activeWishlistAction)) {
          const card = this.getActiveProductSlide()?.querySelector('product-card');
          card?.querySelector('[data-wishlist-toggle]')?.click();
          window.requestAnimationFrame(() => {
            this.updateProductActions(card);
            this.updateStaticActions();
          });
          return;
        }

        if (cartAction && this.contains(cartAction)) {
          this.addProductToCart(cartAction);
          return;
        }

        if (wishlistAction && this.contains(wishlistAction)) {
          const card = wishlistAction.closest('product-card');
          card?.querySelector('[data-wishlist-toggle]')?.click();
          window.requestAnimationFrame(() => this.updateProductActions(card));
        }
      });

      this.handleVariantChange = (event) => {
        const select = event.target.closest('[data-shop-look-variant-select]');
        if (!select || !this.contains(select)) return;

        const option = select.selectedOptions[0];
        const card = select.closest('product-card');
        const cartAction = card?.querySelector('[data-shop-look-card-add-cart]');
        if (!option || !card || !cartAction) return;

        cartAction.dataset.variantId = option.value;
        cartAction.dataset.productAvailable = option.dataset.available;

        const slide = card.closest('.swiper-slide[data-index]');
        if (slide) {
          slide.dataset.variantId = option.value;
          slide.dataset.productAvailable = option.dataset.available;
        }

        this.updateProductActions(card);
        if (slide === this.getActiveProductSlide()) this.updateStaticActions();
      };
      this.addEventListener('change', this.handleVariantChange);

      this.handleWishlistChange = () => {
        this.updateProductActions();
        this.updateStaticActions();
      };
      document.addEventListener('muzdan:wishlist:change', this.handleWishlistChange);
      window.addEventListener('storage', this.handleWishlistChange);

      this.loadCartState();
      window.requestAnimationFrame(() => {
        this.updateProductActions();
        this.updateStaticActions();
      });
    }

    async loadCartState() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;

        const cart = await response.json();
        this.addedVariantIds = new Set(
          cart.items.map((item) => String(item.variant_id))
        );
        this.updateProductActions();
        this.updateStaticActions();
      } catch (error) {
        // Keep the product actions usable if cart state cannot be read.
      }
    }

    getActiveProductSlide() {
      const activeSlide = this.slider?.slides?.[this.slider.activeIndex];
      if (activeSlide?.matches('[data-index]')) return activeSlide;

      const realIndex = this.slider?.realIndex ?? 0;
      return this.querySelector(
        `.shop-the-look__swiper > .swiper-wrapper > .swiper-slide[data-index="${realIndex}"]`
      ) || this.querySelector(
        '.shop-the-look__swiper > .swiper-wrapper > .swiper-slide[data-index="0"]'
      );
    }

    updateStaticActions() {
      const slide = this.getActiveProductSlide();
      const card = slide?.querySelector('product-card');
      const nativeWishlist = card?.querySelector('[data-wishlist-toggle]');
      const cartAction = this.querySelector('[data-shop-look-active-add-cart]');
      const wishlistAction = this.querySelector('[data-shop-look-active-wishlist]');
      const currentCount = this.querySelector('[data-shop-look-current-product]');
      const productId = slide?.dataset.productId;
      const variantId = slide?.dataset.variantId;
      const available = slide?.dataset.productAvailable === 'true';
      const isAdded = variantId && this.addedVariantIds.has(String(variantId));

      if (currentCount && this.slider) {
        currentCount.textContent = String(this.slider.realIndex + 1);
      }

      if (cartAction && cartAction.dataset.loading !== 'true') {
        const hasSelection = Boolean(variantId);
        cartAction.dataset.variantId = variantId || '';
        cartAction.dataset.productAvailable = String(available);
        cartAction.disabled = !hasSelection || !available || Boolean(isAdded);
        cartAction.setAttribute('aria-disabled', String(!hasSelection || Boolean(isAdded)));
        cartAction.textContent = !hasSelection
          ? 'Add to cart'
          : !available
            ? 'Sold out'
            : isAdded
              ? 'Added to cart'
              : 'Add to cart';
      }

      if (wishlistAction) {
        let isSaved = nativeWishlist?.getAttribute('aria-pressed') === 'true';

        try {
          const savedProducts = JSON.parse(
            localStorage.getItem('muzdan:wishlist:v1') || '[]'
          );
          isSaved = Array.isArray(savedProducts) && savedProducts.some(
            (product) => String(product.id) === String(productId)
          );
        } catch (error) {
          // Fall back to the native wishlist button state.
        }

        wishlistAction.disabled = !nativeWishlist;
        wishlistAction.textContent = isSaved ? 'Remove from wishlist' : 'Add to wishlist';
      }
    }

    updateProductActions(scope = this) {
      const cards = scope?.matches?.('product-card')
        ? [scope]
        : scope.querySelectorAll('product-card');

      cards.forEach((card) => {
        const cartAction = card.querySelector('[data-shop-look-card-add-cart]');
        const wishlistAction = card.querySelector('[data-shop-look-card-wishlist]');
        const nativeWishlist = card.querySelector('[data-wishlist-toggle]');

        if (cartAction && cartAction.dataset.loading !== 'true') {
          const variantId = cartAction.dataset.variantId;
          const available = cartAction.dataset.productAvailable === 'true';
          const isAdded = variantId && this.addedVariantIds.has(String(variantId));
          const hasSelection = Boolean(variantId);
          const isDrawerCard = Boolean(card.closest('shop-the-look-drawer'));

          cartAction.disabled = !hasSelection || !available || Boolean(isAdded);
          cartAction.setAttribute('aria-disabled', String(!hasSelection || Boolean(isAdded)));
          cartAction.textContent = !hasSelection
            ? isDrawerCard ? 'Select size' : 'Add to cart'
            : !available
              ? 'Sold out'
              : isAdded
                ? 'Added to cart'
                : 'Add to cart';
        }

        if (wishlistAction) {
          const isSaved = nativeWishlist?.getAttribute('aria-pressed') === 'true';
          wishlistAction.disabled = !nativeWishlist;
          wishlistAction.textContent = isSaved ? 'Remove from wishlist' : 'Add to wishlist';
        }
      });
    }

    async addProductToCart(control) {
      const variantId = control.dataset.variantId;
      if (
        !variantId ||
        control.dataset.productAvailable !== 'true' ||
        control.dataset.loading === 'true' ||
        this.addedVariantIds.has(String(variantId))
      ) return;

      control.dataset.loading = 'true';
      control.disabled = true;
      control.textContent = 'Adding…';

      try {
        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: ['cart-counter', 'cart-drawer'],
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || 'Unable to add product');
        }

        this.refreshCartSections(result.sections);
        this.addedVariantIds.add(String(variantId));
        control.dataset.loading = 'false';
        this.updateProductActions();
        this.updateStaticActions();
      } catch (error) {
        control.textContent = 'Try again';
        control.dataset.loading = 'false';
        control.disabled = false;
      }
    }

    refreshCartSections(sections) {
      if (!sections) return;

      const replacements = [
        ['cart-counter', '#shopify-section-cart-counter'],
        ['cart-drawer', '#CartDrawer-Body']
      ];

      replacements.forEach(([sectionId, selector]) => {
        const target = document.querySelector(selector);
        const html = sections[sectionId];
        if (!target || !html) return;

        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const source = documentFragment.querySelector(selector);
        if (source) target.innerHTML = source.innerHTML;
      });
    }

    updateActiveDot(btn) {
      const currentBtn = this.dotsList?.querySelector(
        '.js-btn.is-current'
      );

      currentBtn.classList.remove('is-current');
      currentBtn.setAttribute('aria-current', false);

      btn.classList.add('is-current');
      btn.setAttribute('aria-current', true);
    }

    initDrawer() {
      const drawer = document.querySelector(
        ".shop-the-look-drawer__blocks"
      );
      const drawerContainer = document.querySelector(
        "shop-the-look-drawer"
      );
      if (!drawer || !drawerContainer) return;
    }
  }

  customElements.define('shop-the-look-slider', ShopTheLookSlider);
}
